module.exports = __webpack_public_path__ + "static/01-a8cf657c267081df38d2b8b238468130.png";